import { render, staticRenderFns } from "./ctoDetail.vue?vue&type=template&id=2c3ce0cf"
import script from "./ctoDetail.vue?vue&type=script&lang=js"
export * from "./ctoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3ce0cf')) {
      api.createRecord('2c3ce0cf', component.options)
    } else {
      api.reload('2c3ce0cf', component.options)
    }
    module.hot.accept("./ctoDetail.vue?vue&type=template&id=2c3ce0cf", function () {
      api.rerender('2c3ce0cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/cto/ctoDetail.vue"
export default component.exports